import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClass = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  }[size] || 'h-8 w-8';

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-blue-600 dark:border-blue-400 ${sizeClass}`}></div>
    </div>
  );
};

export default LoadingSpinner;